import { handleize } from "./productVariants"

const BADGE_PREFIX = "badge:"

export const getProductTags = (product) => {
  const tags = []

  if (Array.isArray(product?.tags)) {
    tags.push(...product.tags)
  }

  if (Array.isArray(product?.tags1)) {
    tags.push(...product.tags1)
  }

  return tags.filter((tag) => typeof tag === "string")
}

export const getBadge = (product) => {
  const badgeTag = getProductTags(product).find((tag) => tag.includes(BADGE_PREFIX))

  if (!badgeTag) return null

  const [, badgeTextRaw = ""] = badgeTag.split(BADGE_PREFIX)
  const badgeText = badgeTextRaw.trim()

  if (!badgeText) return null

  const badgeClassName = handleize(badgeText)
  if (!badgeClassName) return null

  return {
    text: badgeText,
    className: `badge-${badgeClassName}`
  }
}

export const parseBadgeImageValue = (value) => {
  if (!value) return null

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value)
      if (Array.isArray(parsed)) return parsed[0] || null
      return parsed
    } catch (error) {
      console.warn("[Product] Failed to parse badge image value", { value, error })
      return null
    }
  }

  if (Array.isArray(value)) {
    return value[0] || null
  }

  return value
}

export const getBadgeImage = (product) => {
  const metafields = product?.metafields

  if (Array.isArray(metafields)) {
    const field = metafields.find((item) => item?.key === "product_card_badge_image")
    const badgeImage = parseBadgeImageValue(field?.value)
    if (badgeImage?.src) return badgeImage
    return null
  } else if (metafields && typeof metafields === "object") {
    const badgeImageValue = metafields.badgeImage
    if (Array.isArray(badgeImageValue)) {
      const badgeImage = badgeImageValue[0]
      if (badgeImage?.src) return badgeImage
    } else if (badgeImageValue && badgeImageValue.src) {
      return badgeImageValue
    }
  }

  return null
}

export const toNumber = (value) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : null
  if (typeof value === "string" && value.trim().length > 0) {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}
